exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-form {\n  -webkit-box-shadow: 1px 1px 5px #4e4e4e99;\n          box-shadow: 1px 1px 5px #4e4e4e99;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/abeltrotter/Documents/git/epicodus/javascript/portfolio-angular/src/app/login/login.component.css
// module id = ../../../../../src/app/login/login.component.css
// module chunks = main